import { render } from "./CitationSources.vue?vue&type=template&id=518b9a6c&scoped=true"
import script from "./CitationSources.vue?vue&type=script&lang=js"
export * from "./CitationSources.vue?vue&type=script&lang=js"

import "./CitationSources.vue?vue&type=style&index=0&id=518b9a6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518b9a6c"]])

export default __exports__